export class Application {
    id: string;
	name: string;
	logo: string;
	adminUrl: string;
	appUrl: string;
}
